import clsx from "clsx";
import type { DetailedHTMLProps, HTMLAttributes, ReactNode } from "react";
import styles from "./card.module.scss";

interface CardProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  children: ReactNode;
  variant?: "default" | "elevated" | "outlined";
  size?: "small" | "medium" | "large";
  padded?: boolean;
  interactive?: boolean;
  disabled?: boolean;
  loading?: boolean;
}

export const Card = ({
  children,
  className,
  variant = "default",
  size = "medium",
  padded = false,
  interactive = false,
  disabled = false,
  loading = false,
  ...rest
}: CardProps) => {
  const classNames = clsx(
    styles.root,
    {
      [styles[variant]]: variant !== "default",
      [styles[size]]: size !== "medium",
      [styles.padded]: padded,
      [styles.interactive]: interactive,
      [styles.disabled]: disabled,
      [styles.loading]: loading,
    },
    className
  );

  return (
    <div {...rest} className={classNames}>
      {children}
    </div>
  );
};
